import { useEffect } from 'react';

export const useVersion = () => {
  useEffect(() => {
    window.__VERSION__ = process.env.NEXT_PUBLIC_VERSION as string;
  }, []);
};
